import React, { lazy, FC, Suspense } from 'react';
import LoadingSpinner from 'components/elements/loadingSpinner';
import Loader from './Loader';

type Props = {
  page: string;
};

const AsyncComponent: FC<Props> = ({ page }) => {
  const MainComponent = lazy(() => import(`containers/${page}`));
  return (
    <Suspense fallback={<LoadingSpinner loading={true} />}>
      <MainComponent />
    </Suspense>
  );
};

export default AsyncComponent;
